import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import getXcolumnJson from "./xcolumn/list";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import SearchArea from "./search";
import RightWordListArea from "./area/right_word_list";

function ShareWordInsideArea(props: any) {
  let myProps = {
    ...props
  };

  let user = useSelector((state: any) => state.user);
  const ListComponentRef = useRef<any>(null);
  const xColumnArr = getXcolumnJson();
  let now_date_str = DateFunc.get_date_format(new Date(), "Y-m-d");
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_title_like: "",
    s_word_type: "",
    order_id: "a_title",
    s_addon_study_word: "1",
    s_mcomp_seq: "",
  });
  const [from_to_data, set_from_to_data] = useState<any>({
    from_group_seq: "",
    from_comp_seq: "",
    to_group_seq: "",
    to_comp_seq: "",
  });
  const [infoArr, setInfoArr] = useState<any>([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [select_info_arr,set_select_info_arr]=useState<any>([]);

  useEffect(() => {
    //list({});
  }, [user.comp_seq]);

  const list = (inOptObj: any) => {
    let tmp_listOpt: any = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_listOpt);
    if (strFunc.is_empty(tmp_listOpt.s_mcomp_seq)) {
      setInfoArr([]);
      setCountInfo({ "tot": 0 });
      if (ListComponentRef.current) {
        ListComponentRef.current.setInfoArr([]);
      }
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/list', tmp_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const send_to_other = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    let tmp_from_to_data = { ...from_to_data };
    if (user.comp_seq != "4") {
      tmp_from_to_data.to_comp_seq = user.comp_seq;
    }
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (strFunc.is_empty(tmp_from_to_data.from_comp_seq)) {
      alert("보내는학원 선택없음.");
      return false;
    }
    if (strFunc.is_empty(tmp_from_to_data.to_comp_seq)) {
      alert("받는학원 선택없음.");
      return false;
    }
    if (tmp_from_to_data.from_comp_seq == tmp_from_to_data.to_comp_seq) {
      alert("보내는학원과 받는학원이 동일합니다.");
      return false;
    }
    if (!confirm(selected_row.length + "개의 브릿지인사이드를 보내시겠습니까?")) {
      return false;
    }
    let inside_seq_arr = [];
    for (let i = 0; i < selected_row.length; i++) {
      inside_seq_arr.push(selected_row[i]["a_seq"]);
    }

    let share_form_data = {
      "sender_mcomp_seq": tmp_from_to_data.from_comp_seq,
      "receiver_mcomp_seq": tmp_from_to_data.to_comp_seq,
      "inside_seq_arr": inside_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/send_to_other', share_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const customCellRenderer = (params: any) => {
    /*
      {
        "rowData":rowData,
        "idx":idx,
        "key":key,
        "value":row_val,
        "origin_val":origin_val,
      }
    */
    let val_str = params.value;

    if (params.key == "row_view_word_count") {
      if (params.rowData["cg_word_arr"]) {
        val_str = strFunc.comma(params.rowData["cg_word_arr"].length);
      }
      val_str = (
        <div className='text-center'>
          {val_str}개
        </div>
      );
    }

    return val_str;
  };

  const onSelectChange=(select_info_arr: any) => {
    set_select_info_arr(select_info_arr);
  };

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        list={list}
        from_to_data={from_to_data}
        set_from_to_data={set_from_to_data}
        send_to_other={send_to_other}
      ></SearchArea>
      <div className="my_flex_right mt-1">
        <b>총 {strFunc.comma(countInfo.tot)}개</b>
      </div>
      <div className='mt-1'>
        <table>
          <colgroup>
            <col width={"40%"}></col>
            <col width={"*"}></col>
          </colgroup>
          <tbody>
            <tr>
              <td style={{ verticalAlign: "top" }}>
                <div style={{ minWidth: "600px" }}>
                  <ListComponent
                    ref={ListComponentRef}
                    infoArr={infoArr}
                    xColumnArr={xColumnArr}
                    gridOpt={{
                      is_add_idx_num: true,
                      is_add_checkbox: true,
                      td_align: "center",
                      customCellRenderer: customCellRenderer,
                      onSelectChange: onSelectChange,
                    }}
                  ></ListComponent>
                </div>
              </td>
              <td style={{ verticalAlign: "top" }}>
                <div style={{ minWidth: "400px" }}>
                  <RightWordListArea
                    select_info_arr={select_info_arr}
                  ></RightWordListArea>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        is_view_num_per_page={true}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
    </div>
  );
};
export default ShareWordInsideArea;